export enum NodeType {
  BRANCH = 0,
  ITEM = 1,
  ACCESSORY = 2,
}
